import { FC } from "react";
import Upsale from "./Upsale";
import TicketUpsale from "app/WebEvent/types/TicketUpsale";
import { useBasket, useBasketDispatch } from "../basketContext";
import BasketReducerActions from "../enums/BasketReducerActions";

type OrdinaryUpsaleProps = {
    upsale: TicketUpsale;
};

const OrdinaryUpsale: FC<OrdinaryUpsaleProps> = ({ upsale }) => {
    const { upsales } = useBasket();
    const dispatch = useBasketDispatch();

    const basketUpsale = upsales.find((eUpsale) => eUpsale.id === upsale.id);

    const handleChange = (quantity: number) => {
        dispatch?.({
            type: BasketReducerActions.CHANGE_UPSALE_QUANTITY,
            payload: {
                upsale,
                quantity,
            },
        });
    };

    return (
        <Upsale
            upsale={upsale}
            quantity={basketUpsale ? basketUpsale.quantity : 0}
            onChange={handleChange}
        />
    );
};

export default OrdinaryUpsale;
